import React, { createContext } from "react";
import Initializer from "./components/Initializer";
import GraphSim from "./components/GraphSim";
import NetworkVisualization from "./networkviz/networkViz";
import { Grid, Button, Typography, Box } from "@mui/material";
import RadioButtonsGroup from "./components/Common/CustomRadio";
import { directiontypesData, graphtypesData } from "./data/assetsData";
import CustomButton from "./components/Common/CustomButton";
import CustomInput from "./components/Common/CustomInput";
import OptionsComponent from "./components/OptionsComponent";
import GraphContextProvider from "./context";
import GraphDisplayComponent from "./components/GraphDisplayComponent";
import ResultComponent from "./components/ResultComponent";
import MainComponent from "./components/Common/MainComponent";

const App = () => {
  return (
    <div style={{ width: "100vw", height: "100vh", display: "flex" }}>
      <GraphContextProvider>
        <MainComponent />
      </GraphContextProvider>
    </div>
  );
};

export default App;
